import { instances } from '@/services/http';
import { useMutation, useQueryClient } from '@tanstack/vue-query';
import type { UserDashboardConfirmParticipationResponseType } from '@magma-app/magma-types/user-dashboard/event';
import type { UploadedFile } from '@/composables/useUgcFileUpload';

export const useConfirmParticipation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (payload: {
      userEventId: number;
      textProof?: string;
      fileKeys?: UploadedFile[];
    }) => {
      const { userEventId, ...rest } = payload;
      const response = await instances.userDashboard.put(
        `events/${userEventId}/confirm-participation`,
        rest
      );
      return response.data as UserDashboardConfirmParticipationResponseType;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['events'] });
    },
  });
};
